import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'

const Extras = () => {

  return (
    <>
    <div className="container">
      <Disclosure defaultOpen>
        {({ open }) => (
          <>
            <Disclosure.Button className="flex w-full justify-between rounded-lg bg-stone-100 px-4 py-2 text-left text-sm font-medium">
              <h3 className="text-2xl">Gratis bij iedere boeking</h3>
              <ChevronDownIcon
                className={`${
                  open ? 'rotate-180 transform' : ''
                } h-5 w-5 text-slate-900`}
              />
            </Disclosure.Button>
            <Disclosure.Panel className={`bg-stone-100 rounded-b-lg px-4 pb-2 pt-1 text-sm text-gray-500 mb-5`}>
              <ul className="font-inter text-left" style={{ listStyleType: 'none' }}>
                <li style={{ position: 'relative', marginLeft: '4px', marginTop:'4px' }}>
                  <span style={{ position: 'relative', left: '0', color: 'green', fontSize: '1.2em', top: '1px' }}>&#10003;</span>
                  Dé SurfaWhile Surf Guide gratis in je mailbox
                </li>
                <li style={{ position: 'relative', marginLeft: '4px', marginTop:'4px' }}>
                  <span style={{ position: 'relative', left: '0', color: 'green', fontSize: '1.2em', top: '1px' }}>&#10003;</span>
                  € 25,- p.p. korting in de{' '}
                  <Link to="https://shop.surfawhile.com" className="underline">
                    SurfaWhile Webshop
                  </Link>
                </li>
                <li style={{ position: 'relative', marginLeft: '4px', marginTop:'4px' }}>
                  <span style={{ position: 'relative', left: '0', color: 'green', fontSize: '1.2em', top: '1px' }}>&#10003;</span>
                  Travel Guide met insider tips van jouw bestemming
                </li>
                <li style={{ position: 'relative', marginLeft: '4px', marginTop:'4px' }}>
                  <span style={{ position: 'relative', left: '0', color: 'green', fontSize: '1.2em', top: '1px' }}>&#10003;</span>
                  Gratis advies van onze surf &amp; travel experts
                </li>
              </ul>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      </div>
    </>
  )
}

export default Extras